'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

var _datamasterForms = require("datamaster-forms");

var _formInputs = require("./../form-inputs");

var _modal = _interopRequireDefault(require("../modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

/**
 *
 * @param target
 */
var scrollTo = function scrollTo(target) {
  var destination = document.getElementById(target);
  var container = document.querySelector('.app-content');
  var offset = 0;

  if (destination.offsetParent) {
    offset += destination.offsetParent.offsetTop;
  }

  offset += destination.offsetTop;
  setTimeout(function () {
    container.scrollTo(0, offset);
  }, 200);
};
/**
 *
 * @param outlet
 * @param fieldName
 * @param value
 * @param farm
 * @returns {*}
 */


var mapOutletData = function mapOutletData(outlet, fieldName, value, farm) {
  if (fieldName !== 'addresstype') return outlet; // set to own address: reset to farm data

  if (value.id === 1 && outlet.addresstype.id === 2) {
    outlet.street = farm.street;
    outlet.zip = farm.zip;
    outlet.city = farm.city;
    outlet.longitude = outlet.latitude = '';
  } // set to other address: clear data. latitude and longitude are not set in this case


  if (value.id === 2 && outlet.addresstype.id === 1) {
    outlet.street = outlet.zip = outlet.city = '';
  }

  return outlet;
};

var VomhofForm = /*#__PURE__*/function (_BaseForm) {
  _inherits(VomhofForm, _BaseForm);

  function VomhofForm(props) {
    var _this;

    _classCallCheck(this, VomhofForm);

    _this = _possibleConstructorReturn(this, (VomhofForm.__proto__ || Object.getPrototypeOf(VomhofForm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      vomhofNotFound: !props.project,
      vomhofEdit: false,
      vomhof: props.project,
      uploadModalOpen: {
        files: {},
        images: {}
      },
      metarubric: [],
      rubric: [],
      category: [],
      manufacturetype: [],
      product: [],
      availability: [],
      paymentmethod: [],
      vacation_categories: [],
      offer: [],
      outletCategories: [],
      vomhofIsSaving: {},
      form: {
        isEditable: false,
        error: {
          project: {}
        },
        invalidFields: {
          project: {
            fields: [],
            details: {}
          }
        },
        success: {}
      },
      offerToDelete: null,
      vacationToDelete: null,
      outletToDelete: null,
      deleting: false
    });
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.addOffer = _this.addOffer.bind(_assertThisInitialized(_this));
    _this.onRemoveOffer = _this.onRemoveOffer.bind(_assertThisInitialized(_this));
    _this.removeOffer = _this.removeOffer.bind(_assertThisInitialized(_this));
    _this.saveOffer = _this.saveOffer.bind(_assertThisInitialized(_this));
    _this.addVacation = _this.addVacation.bind(_assertThisInitialized(_this));
    _this.onRemoveVacation = _this.onRemoveVacation.bind(_assertThisInitialized(_this));
    _this.removeVacation = _this.removeVacation.bind(_assertThisInitialized(_this));
    _this.saveVacation = _this.saveVacation.bind(_assertThisInitialized(_this));
    _this.addOutlet = _this.addOutlet.bind(_assertThisInitialized(_this));
    _this.onRemoveOutlet = _this.onRemoveOutlet.bind(_assertThisInitialized(_this));
    _this.removeOutlet = _this.removeOutlet.bind(_assertThisInitialized(_this));
    _this.saveOutlet = _this.saveOutlet.bind(_assertThisInitialized(_this));
    _this.onDeleteFile = _this.onDeleteFile.bind(_assertThisInitialized(_this));
    _this.onUploadFile = _this.onUploadFile.bind(_assertThisInitialized(_this));
    _this.onUpdateSorting = _this.onUpdateSorting.bind(_assertThisInitialized(_this));
    _this.onProjectInputChange = _this.onProjectInputChange.bind(_assertThisInitialized(_this));
    _this.saveProject = _this.saveProject.bind(_assertThisInitialized(_this));
    _this.renderRemoveModal = _this.renderRemoveModal.bind(_assertThisInitialized(_this));
    _this.onGeocode = _this.onGeocode.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VomhofForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var loadRelatedDataCollection = function loadRelatedDataCollection(url, name) {
        // Load categories and subcategories
        fetch(url, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (objects) {
          _this2.setState(function (prev) {
            prev[name] = objects;
            return prev;
          });
        }).catch(console.error);
      }; // Load project related data


      loadRelatedDataCollection(_conf.default.api.manufacturetypeApiUrlTemplate(this.props.i18n.language), 'manufacturetype');
      loadRelatedDataCollection(_conf.default.api.metarubricApiUrlTemplate(this.props.i18n.language), 'metarubric');
      loadRelatedDataCollection(_conf.default.api.offerCategoryApiUrlTemplate(this.props.i18n.language), 'offer');
      loadRelatedDataCollection(_conf.default.api.productApiUrlTemplate(this.props.i18n.language), 'product');
      loadRelatedDataCollection(_conf.default.api.rubricApiUrlTemplate(this.props.i18n.language), 'rubric');
      loadRelatedDataCollection(_conf.default.api.availabilityApiUrlTemplate(this.props.i18n.language), 'availability');
      loadRelatedDataCollection(_conf.default.api.paymentMehtodApiUrlTemplate(this.props.i18n.language), 'paymentmethod');
      loadRelatedDataCollection(_conf.default.api.vacationCategorieApiUrlTemplate(this.props.i18n.language), 'vacation_categories');
      loadRelatedDataCollection(_conf.default.api.outletCategoriesAPITemplate(this.props.i18n.language), 'outletCategories');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      var buildUploadUrl = function buildUploadUrl(offerId, type) {
        return "/api/".concat(_this3.props.i18n.language, "/farms/").concat(_this3.props.id, "/vomhof/offer/").concat(offerId, "/").concat(type);
      };

      this.state.availability = [{
        id: 1,
        name: t('Januar')
      }, {
        id: 2,
        name: t('Februar')
      }, {
        id: 3,
        name: t('März')
      }, {
        id: 4,
        name: t('April')
      }, {
        id: 5,
        name: t('Mai')
      }, {
        id: 6,
        name: t('Juni')
      }, {
        id: 7,
        name: t('Juli')
      }, {
        id: 8,
        name: t('August')
      }, {
        id: 9,
        name: t('September')
      }, {
        id: 10,
        name: t('Oktober')
      }, {
        id: 11,
        name: t('November')
      }, {
        id: 12,
        name: t('Dezember')
      }];
      var texts = {
        sectionOffers: {
          sectionTitle: t('offers'),
          save: t('Speichern')
        },
        sectionOther: {
          sectionTitle: t('Sonstiges'),
          openingHours: t('Öffnungszeiten'),
          comments: t('Bemerkung'),
          save: t('Speichern')
        },
        product: {
          remove: t('Angebot entfernen'),
          save: t('Speichern'),
          metarubric: t('metarburic'),
          rubric: t('rubric'),
          category: t('category'),
          product: t('product'),
          pleaseChoose: t('Bitte wählen'),
          chooseCategory: t('Zuerst Kategorie wählen'),
          chooseRubric: t('Zuerst Rubrik wählen'),
          chooseMetarubric: t('Zuerst Metarubrik wählen'),
          deleteImageModalTitle: this.props.t('Soll das Bild wirklich gelöscht werden?'),
          deleteImageModalText: this.props.t('Das Bild wird unwiderruflich gelöscht'),
          deleteFileModalTitle: this.props.t('Soll die Datei wirklich gelöscht werden?'),
          deleteFileModalText: this.props.t('Die Datei wird unwiderruflich gelöscht'),
          yes: this.props.t('yes'),
          no: this.props.t('no'),
          images: this.props.t('Bilder'),
          files: this.props.t('Dateien')
        },
        vacation: {
          remove: t('Angebot entfernen'),
          save: t('Speichern'),
          pleaseChoose: t('Bitte wählen'),
          category: t('category')
        }
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-farm comp-base-form comp-vomhof"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "Vomhof",
        className: "form-title"
      }, t('Project data')), this.state.vomhofNotFound && /*#__PURE__*/_react.default.createElement("p", null, t('Not registered')), !_lodash.default.isEmpty(this.state.vomhof) ? /*#__PURE__*/_react.default.createElement(_datamasterForms.ProjectVomhofForm, {
        t: t,
        projectSearchUrl: "/api/".concat(this.props.i18n.language, "/search/product"),
        handleInputChange: this.handleInputChange,
        onProjectInputChange: this.onProjectInputChange,
        addProduct: this.addOffer,
        saveOffer: this.saveOffer,
        removeOffer: this.onRemoveOffer,
        addVacation: this.addVacation,
        saveVacation: this.saveVacation,
        saveProject: this.saveProject,
        removeVacation: this.onRemoveVacation,
        addOutlet: this.addOutlet,
        removeOutlet: this.onRemoveOutlet,
        saveOutlet: this.saveOutlet,
        onGeocode: this.onGeocode,
        shared: {
          loading: {
            products: false,
            vacation_categories: false,
            metarubrics: false,
            rubrics: false,
            categories: false
          },
          products: this.state.product,
          vacation_categories: this.state.vacation_categories,
          months: this.state.availability,
          metarubrics: this.state.metarubric,
          manufacturetypes: this.state.manufacturetype,
          rubrics: this.state.rubric,
          offer_categories: this.state.offer,
          payment_method: this.state.paymentmethod,
          outlet_category: this.state.outletCategories
        },
        project: this.state.vomhof,
        progress: {},
        texts: texts,
        error: this.state.form.error,
        invalidFields: this.state.form.invalidFields,
        success: this.state.form.success,
        isSaving: this.state.vomhofIsSaving,
        imageUpload: {
          onDeleteImage: function onDeleteImage(offerId, file, type) {
            return _this3.onDeleteFile(file.id, offerId, type);
          },
          imageUploadUrl: buildUploadUrl,
          onImageUpload: function onImageUpload(offerId, files, type) {
            _this3.onUploadFile(files, offerId, type);
          },
          onUpdateSorting: this.onUpdateSorting
        },
        addressTypes: this.props.addressTypes,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputSelect: _formInputs.AdapterSelect,
        InputField: _formInputs.AdapterText,
        InputTextarea: _formInputs.TextareaInput,
        InputRadioGroup: _formInputs.InputRadioGroup,
        InputCheckbox: _formInputs.CheckboxInput,
        scrollTo: scrollTo,
        otherOutletEnabled: this.props.otherOutletEnabled
      }) : null, this.state.offerToDelete && this.renderRemoveModal(this.state.offerToDelete, this.removeOffer, 'offerToDelete', 'confirm-remove-offer', 'Angebot wirklich entfernen?'), this.state.vacationToDelete && this.renderRemoveModal(this.state.vacationToDelete, this.removeVacation, 'vacationToDelete', 'confirm-remove-vacation', 'Angebot wirklich entfernen?'), this.state.outletToDelete && this.renderRemoveModal(this.state.outletToDelete, this.removeOutlet, 'outletToDelete', 'confirm-remove-outlet', 'datamaster-forms:::vomhof-outlets-confirm-remove'));
    }
    /**
     *
     * @param isOpen
     * @param removeFunction
     * @param stateProperty
     * @param id
     * @returns {*}
     */

  }, {
    key: "renderRemoveModal",
    value: function renderRemoveModal(isOpen, removeFunction, stateProperty, id, heading) {
      var _this4 = this;

      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: id,
        classes: 'confirm-remove-offer-class',
        isOpen: isOpen,
        backgroundClickClose: true,
        escClose: true
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, t(heading)), /*#__PURE__*/_react.default.createElement("div", {
        className: 'button-group'
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "button inline-style",
        onClick: function onClick() {
          return _this4.setState(function (prev) {
            prev[stateProperty] = null;
            return prev;
          });
        }
      }, t('no')), /*#__PURE__*/_react.default.createElement("button", {
        className: "button inline-style",
        onClick: function onClick() {
          return removeFunction();
        }
      }, t('yes')))), this.state.deleting && /*#__PURE__*/_react.default.createElement(_datamasterForms.Loader, {
        size: 'medium'
      }));
    }
    /**
     *
     * @param type
     * @param id
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(type, id, fieldName, value) {
      var _this5 = this;

      var changeTypeArray = this.state.vomhof[type];

      var firstIndex = _lodash.default.findIndex(changeTypeArray, {
        id: id
      });

      this.setState(function (prev) {
        if (type === 'outlets') {
          prev.vomhof[type][firstIndex] = mapOutletData(prev.vomhof[type][firstIndex], fieldName, value, _this5.props.farm);
        }

        prev.vomhof[type][firstIndex][fieldName] = value;

        if (fieldName === 'metarubric') {
          prev.vomhof[type][firstIndex].rubric = prev.vomhof[type][firstIndex].category = prev.vomhof[type][firstIndex].product = [];
        }

        if (fieldName === 'rubric') {
          prev.vomhof[type][firstIndex].category = prev.vomhof[type][firstIndex].product = [];
        }

        if (fieldName === 'category' && type === 'offers') {
          prev.vomhof[type][firstIndex].product = [];
        }

        return prev;
      });
    }
    /**
     *
     */

  }, {
    key: "addOffer",
    value: function addOffer(productId) {
      var _this6 = this;

      if (!this.props.id) {
        return void 0;
      }

      return fetch(_conf.default.api.vomhofAddOffer(this.props.i18n.language, this.props.id), {
        method: 'POST',
        body: JSON.stringify({
          product_id: productId
        }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updatedProduct) {
        _this6.setState(function (prev) {
          prev.vomhof.offers.push(updatedProduct);
          prev.vomhof.offers.sort(function (offerA, offerB) {
            // sort empty products at the top
            if (!offerA.product || !offerA.product.name) {
              return -1;
            }

            if (!offerA.product || !offerB.product.name) {
              return 1;
            }

            return offerA.product.name.localeCompare(offerB.product.name);
          });
          return prev;
        });

        return Promise.resolve({
          value: updatedProduct
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this6.setState(function (prev) {
          prev.form = {
            error: {
              project: message
            },
            invalidFields: {
              project: {
                fields: Object.keys(invalidFields),
                details: invalidFields
              }
            },
            success: {}
          };
          return prev;
        });
      });
    }
    /**
     *
     * @returns {Promise<Response>}
     */

  }, {
    key: "saveProject",
    value: function saveProject(section) {
      var _this7 = this;

      section = section || 'general';
      this.setState(function (prev) {
        prev.vomhofIsSaving[section] = true;
        return prev;
      });

      var projectData = _lodash.default.cloneDeep(this.state.vomhof);

      if (section !== 'other_outlets') {
        delete projectData.other_outlets;
      }

      return fetch(_conf.default.api.vomhofUpdateProject(this.props.i18n.language, this.props.id), {
        method: 'PUT',
        body: JSON.stringify(projectData),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this7.setState(function (prev) {
          prev.vomhofIsSaving[section] = false;

          if (!prev.form) {
            prev.form = {
              isEditable: false,
              error: {
                general: null,
                other_outlets: null
              },
              invalidFields: {
                general: {
                  fields: [],
                  details: {}
                },
                other_outlets: {
                  fields: [],
                  details: {}
                }
              },
              success: {}
            };
          }

          prev.form.success[section] = true;
          prev.form.error[section] = null;
          prev.form.invalidFields[section] = {
            fields: [],
            details: []
          };
          return prev;
        });

        setTimeout(function () {
          _this7.setState(function (prev) {
            prev.form.success[section] = false;
            return prev;
          });
        }, 3000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this7.setState(function (prev) {
          prev.form.error[section] = message;
          prev.form.invalidFields[section] = {
            fields: Object.keys(invalidFields),
            details: invalidFields
          };
          prev.form.success[section] = false;
          prev.vomhofIsSaving[section] = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param name
     * @param value
     */

  }, {
    key: "onProjectInputChange",
    value: function onProjectInputChange(name, value) {
      this.setState(function (prev) {
        prev.vomhof[name] = value;
        return prev;
      });
    }
    /**
     *
     * @param offerId
     */

  }, {
    key: "saveOffer",
    value: function saveOffer(offerId) {
      var _this8 = this;

      if (!this.props.id) {
        return void 0;
      }

      this.setState(function (prev) {
        prev.vomhofIsSaving[offerId] = true;
        return prev;
      });
      var index = this.state.vomhof.offers.findIndex(function (offer) {
        return offer.id === offerId;
      });

      var offer = _lodash.default.cloneDeep(this.state.vomhof.offers[index]);

      delete offer.images;
      delete offer.files;
      return fetch(_conf.default.api.vomhofUpdateOffer(this.props.i18n.language, this.props.id, offerId), {
        method: 'PUT',
        body: JSON.stringify(offer),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this8.setState(function (prev) {
          prev.vomhofIsSaving[offerId] = false;
          prev.form.success[offerId] = true;
          delete prev.form.error[offerId];
          delete prev.form.invalidFields[offerId];
          return prev;
        });

        setTimeout(function () {
          _this8.setState(function (prev) {
            prev.form.success[offerId] = false;
            return prev;
          });
        }, 3000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this8.setState(function (prev) {
          prev.form.error[offerId] = message;
          prev.form.invalidFields[offerId] = {
            fields: Object.keys(invalidFields),
            details: invalidFields
          };
          prev.form.success[offerId] = false;
          prev.vomhofIsSaving[offerId] = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param offerId
     * @returns {*}
     */

  }, {
    key: "onRemoveOffer",
    value: function onRemoveOffer(offerId) {
      if (!this.props.id) {
        return void 0;
      }

      this.setState(function (prev) {
        prev.offerToDelete = offerId;
        return prev;
      });
    }
    /**
     *
     * @returns {Promise<Response>|void}
     */

  }, {
    key: "removeOffer",
    value: function removeOffer() {
      var _this9 = this;

      if (!this.props.id) {
        return void 0;
      }

      return fetch(_conf.default.api.vomhofUpdateOffer(this.props.i18n.language, this.props.id, this.state.offerToDelete), {
        method: 'DELETE',
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (offerRemoved) {
        _this9.setState(function (prev) {
          prev.vomhof.offers = prev.vomhof.offers.filter(function (offer) {
            return offer.id !== offerRemoved.offerRemoved;
          });
          prev.offerToDelete = null;
          prev.deleting = false;
          return prev;
        });
      });
    }
    /**
     *
     */

  }, {
    key: "addVacation",
    value: function addVacation(productId) {
      var _this10 = this;

      if (!this.props.id) {
        return void 0;
      }

      return fetch(_conf.default.api.vomhofAddVacation(this.props.i18n.language, this.props.id), {
        method: 'POST',
        body: JSON.stringify({
          vacation_id: productId
        }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updatedProduct) {
        _this10.setState(function (prev) {
          prev.vomhof.vacations.push(updatedProduct);
          prev.vomhof.vacations.sort(function (vacationA, vacationB) {
            if (!vacationA.category || !vacationA.category.name) {
              return -1;
            }

            if (!vacationB.category || !vacationB.category.name) {
              return 1;
            }

            return vacationA.category.name.localeCompare(vacationB.category.name);
          });
          return prev;
        });

        return Promise.resolve({
          value: updatedProduct
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this10.setState(function (prev) {
          prev.form = {
            error: message,
            invalidFields: {
              fields: Object.keys(invalidFields),
              details: invalidFields
            },
            success: false
          };
          return prev;
        });
      });
    }
    /**
     *
     * @param vacationId
     */

  }, {
    key: "saveVacation",
    value: function saveVacation(vacationId) {
      var _this11 = this;

      if (!this.props.id) {
        return void 0;
      }

      this.setState(function (prev) {
        prev.vomhofIsSaving["v-".concat(vacationId)] = true;
        return prev;
      });
      var index = this.state.vomhof.vacations.findIndex(function (vacation) {
        return vacation.id === vacationId;
      });

      var offer = _lodash.default.cloneDeep(this.state.vomhof.vacations[index]);

      delete offer.images;
      delete offer.files;
      return fetch(_conf.default.api.vomhofUpdateVacation(this.props.i18n.language, this.props.id, vacationId), {
        method: 'PUT',
        body: JSON.stringify(offer),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function () {
        _this11.setState(function (prev) {
          var id = "v-".concat(vacationId);
          prev.vomhofIsSaving[id] = false;
          prev.form.success[id] = true;
          delete prev.form.error[id];
          delete prev.form.invalidFields[id];
          setTimeout(function () {
            _this11.setState(function (prev) {
              prev.form.success[id] = false;
              return prev;
            });
          }, 3000);
          return prev;
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this11.setState(function (prev) {
          prev.form.error["v-".concat(vacationId)] = message;
          prev.form.invalidFields["v-".concat(vacationId)] = {
            fields: Object.keys(invalidFields),
            details: invalidFields
          };
          prev.form.success["v-".concat(vacationId)] = false;
          prev.vomhofIsSaving["v-".concat(vacationId)] = false;
          prev.vomhofIsSaving["v-".concat(vacationId)] = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param vacationId
     */

  }, {
    key: "onRemoveVacation",
    value: function onRemoveVacation(vacationId) {
      this.setState(function (prev) {
        prev.vacationToDelete = vacationId;
        return prev;
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "removeVacation",
    value: function removeVacation() {
      var _this12 = this;

      if (!this.props.id) {
        return void 0;
      }

      return fetch(_conf.default.api.vomhofUpdateVacation(this.props.i18n.language, this.props.id, this.state.vacationToDelete), {
        method: 'DELETE',
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (vacationRemoved) {
        _this12.setState(function (prev) {
          prev.vomhof.vacations = prev.vomhof.vacations.filter(function (vacation) {
            return vacation.id !== vacationRemoved.vacationRemoved;
          });
          prev.vacationToDelete = null;
          prev.deleting = false;
          return prev;
        });
      });
    }
    /**
     *
     */

  }, {
    key: "addOutlet",
    value: function addOutlet(outletCategoryId) {
      var _this13 = this;

      if (!this.props.id) {
        return void 0;
      }

      if (outletCategoryId === 'other_outlets') {
        this.props.enableOtherOutlet(true);
        return Promise.resolve();
      }

      return fetch(_conf.default.api.vomhofAddOutlet(this.props.i18n.language, this.props.id), {
        method: 'POST',
        body: JSON.stringify({
          outlet_category_id: outletCategoryId
        }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updateOutlet) {
        _this13.setState(function (prev) {
          updateOutlet = _this13.props.mapAddressType(updateOutlet);
          prev.vomhof.outlets.push(updateOutlet);
          prev.vomhof.outlets.sort(function (outletA, outletB) {
            if (outletA.category.name === outletB.category.name) {
              return outletA.city.localeCompare(outletB.city);
            }

            return outletA.category.name.localeCompare(outletB.category.name);
          });
          return prev;
        });

        return Promise.resolve({
          value: updateOutlet
        });
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this13.setState(function (prev) {
          prev.form = {
            error: message,
            invalidFields: {
              fields: Object.keys(invalidFields),
              details: invalidFields
            },
            success: false
          };
          return prev;
        });
      });
    }
    /**
     *
     * @param outletId
     */

  }, {
    key: "saveOutlet",
    value: function saveOutlet(outletId) {
      var _this14 = this;

      if (!this.props.id) {
        return void 0;
      }

      if (outletId === 'other_outlets') {
        return this.saveProject(outletId);
      }

      this.setState(function (prev) {
        prev.vomhofIsSaving["o-".concat(outletId)] = true;
        return prev;
      });
      var index = this.state.vomhof.outlets.findIndex(function (outlet) {
        return outlet.id === outletId;
      });

      var outlet = _lodash.default.cloneDeep(this.state.vomhof.outlets[index]);

      return fetch(_conf.default.api.vomhofUpdateOutlet(this.props.i18n.language, this.props.id, outletId), {
        method: 'PUT',
        body: JSON.stringify(outlet),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        var id = "o-".concat(outletId);

        _this14.setState(function (prev) {
          prev.vomhofIsSaving[id] = false;
          prev.form.success[id] = true;
          delete prev.form.error[id];
          delete prev.form.invalidFields[id];
          return prev;
        });

        setTimeout(function () {
          _this14.setState(function (prev) {
            prev.form.success[id] = false;
            return prev;
          });
        }, 3000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this14.setState(function (prev) {
          prev.form.error["o-".concat(outletId)] = message;
          prev.form.invalidFields["o-".concat(outletId)] = {
            fields: Object.keys(invalidFields),
            details: invalidFields
          };
          prev.form.success["o-".concat(outletId)] = false;
          prev.vomhofIsSaving["o-".concat(outletId)] = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param outletId
     */

  }, {
    key: "onGeocode",
    value: function onGeocode(outletId) {
      var index = this.props.project.outlets.findIndex(function (outlet) {
        return outlet.id === outletId;
      });
      var outlet = this.props.project.outlets[index];
      var geoData = [outlet.street, outlet.zip + ' ' + outlet.city];
      var fullAddress = geoData.join(', ');
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        address: fullAddress
      }, function (res, status) {
        if (status === 'OK') {
          this.handleInputChange('outlets', outletId, 'latitude', res[0].geometry.location.lat());
          this.handleInputChange('outlets', outletId, 'longitude', res[0].geometry.location.lng());
        } else {
          void 0;
        }
      }.bind(this));
    }
    /**
     *
     * @param outletId
     */

  }, {
    key: "onRemoveOutlet",
    value: function onRemoveOutlet(outletId) {
      this.setState(function (prev) {
        prev.outletToDelete = outletId;
        return prev;
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "removeOutlet",
    value: function removeOutlet() {
      var _this15 = this;

      if (!this.props.id) {
        return void 0;
      }

      if (this.state.outletToDelete === 'other_outlets') {
        return fetch(_conf.default.api.vomhofDeleteOtherOutlet(this.props.i18n.language, this.props.id), {
          method: 'DELETE',
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function () {
          _this15.setState(function (prev) {
            prev.outletToDelete = null;
            prev.deleting = false;
            prev.vomhof.other_outlets = '';
            return prev;
          });

          _this15.props.enableOtherOutlet(false);
        });
      }

      return fetch(_conf.default.api.vomhofUpdateOutlet(this.props.i18n.language, this.props.id, this.state.outletToDelete), {
        method: 'DELETE',
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (outletRemoved) {
        _this15.setState(function (prev) {
          prev.vomhof.outlets = prev.vomhof.outlets.filter(function (outlet) {
            return outlet.id !== outletRemoved.outletRemoved;
          });
          prev.outletToDelete = null;
          prev.deleting = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param files
     * @param parentId
     * @param type
     */

  }, {
    key: "onUploadFile",
    value: function onUploadFile(files, parentId, type) {
      this.setState(function (prev) {
        var index = _lodash.default.findIndex(prev.vomhof.offers, {
          id: parentId
        });

        prev.vomhof.offers[index][type] = prev.vomhof.offers[index][type].concat(files);
        return prev;
      });
    }
    /**
     *
     * @param imageId
     * @param type
     * @param parentId
     */

  }, {
    key: "onDeleteFile",
    value: function onDeleteFile(imageId, parentId, type) {
      var _this16 = this;

      var uri = _conf.default.api.vomhofOfferRemoveImage(this.props.i18n.language, this.props.id, parentId, imageId);

      if (type === 'files') uri = _conf.default.api.vomhofOfferRemoveFile(this.props.i18n.language, this.props.id, parentId, imageId);
      return fetch(uri, {
        credentials: 'include',
        method: 'DELETE'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this16.setState(function (prev) {
          var offer = _lodash.default.findIndex(prev.vomhof.offers, {
            id: result.offerId
          });

          prev.vomhof.offers[offer][type] = prev.vomhof.offers[offer][type].filter(function (image) {
            return image.id !== result.fileId;
          });
          return prev;
        });
      });
    }
  }, {
    key: "onUpdateSorting",
    value: function onUpdateSorting(offerId, files) {
      var _this17 = this;

      var uri = _conf.default.api.vomhofOfferUpdateFileSorting(this.props.i18n.language, this.props.id, offerId);

      return fetch(uri, {
        credentials: 'include',
        method: 'PUT',
        body: JSON.stringify(files),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (_ref) {
        var allImages = _ref.allImages;

        _this17.setState(function (prev) {
          var updated = false;
          prev.vomhof.offers.forEach(function (offer) {
            if (parseInt(offer.id) === parseInt(offerId) && !updated) {
              offer.images = allImages;
            }
          });
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
    /**
     *
     */

  }, {
    key: "resetEditMode",
    value: function resetEditMode() {
      this.setState(function (prev) {
        prev.form = {
          isEditable: false,
          error: {
            project: null
          },
          invalidFields: {
            project: {
              fields: [],
              details: {}
            }
          },
          success: {}
        };
        return prev;
      });
    }
  }]);

  return VomhofForm;
}(_baseForm.default);

var _default = (0, _translate.default)(VomhofForm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/vomhof/vomhof.js
// module id = 719
// module chunks = 0